import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const EmpowermentApplication = () => {
  const navigate = useNavigate();

  const handleRegisterClick = () => {
    // Add any registration logic here, if necessary
    navigate('/register'); // Navigate to the registration page
  };

  return (
    <div style={styles.container}>
      <h1>Empowerment Application</h1>
      <p>Coming Soon! Register first to stay updated.</p>
      <button onClick={handleRegisterClick} style={styles.button}>Register</button>
      <Link to="/" style={styles.link}>Go to Home Page</Link>
    </div>
  );
};

const styles = {
  container: {
    textAlign: 'center',
    margin: '50px auto',
    padding: '20px',
    maxWidth: '500px',
    border: '1px solid #ccc',
    borderRadius: '8px',
    backgroundColor: '#f9f9f9',
  },
  button: {
    display: 'inline-block',
    margin: '10px 0',
    padding: '10px 20px',
    fontSize: '16px',
    color: '#fff',
    backgroundColor: 'green',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  link: {
    display: 'block',
    marginTop: '20px',
    fontSize: '16px',
    color: '#007bff',
    textDecoration: 'none',
  }
};

export default EmpowermentApplication;
